import { createContext, useEffect, useState, type ReactNode } from 'react'

export const ThemeContext = createContext<{
  isDark: boolean
  setIsDark: (isDark: boolean) => void
}>({
  isDark: false,
  setIsDark: () => {},
})
export function ThemeProvider({ children }: { children: ReactNode }) {
  const [isDark, setIsDark] = useState(() => {
    const storedTheme = localStorage.getItem('theme')

    if (storedTheme) return storedTheme === 'dark'

    return document.body.classList.contains('dark')
  })

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDark)
    localStorage.setItem('theme', isDark ? 'dark' : 'light')
  }, [isDark])

  return <ThemeContext.Provider value={{ isDark, setIsDark }}>{children}</ThemeContext.Provider>
}
